export type PetPolicyTemplateSettings = {
  enabled: boolean;
  general?: PetPolicyGeneralGroup;
  cats?: PetPolicySpeciesGroup;
  dogs?: PetPolicySpeciesGroup;
  // PX FE only, not sent to API -- handles form state
  restrictions?: PetRestriction[];
};

export type PetPolicyGeneralGroup = {
  max_pets_count?: number | null;
  service_animals_allowed?: boolean | null;
  esa_allowed?: boolean | null;
  custom_rules?: PetPolicyCustomRule[];
};

export type PetPolicySpeciesGroup = {
  allowed?: boolean | null;
  max_weight_lbs?: number | null;
  restricted_breeds?: string[];
  custom_rules?: PetPolicyCustomRule[];
};

export type PetPolicyCustomRule = {
  title: string;
  description: string | null;
};

export enum PetRestrictionCategory {
  General = "General restrictions",
  Dog = "Dogs",
  Cat = "Cats"
}

export type PetRestriction = {
  category: PetRestrictionCategory;
  type: PetRestrictionType;
  value?: string | number | boolean | null;
  // Only applies to custom fields
  title?: string;
};

export enum PetRestrictionType {
  CustomField = "custom_rules",
  // General only
  ServiceAnimal = "service_animals_allowed",
  Esa = "esa_allowed",
  // Dog/Cat only
  Allowed = "allowed",
  Weight = "max_weight_lbs",
  Breed = "restricted_breeds",
  Count = "max_pets_count"
}
